import Script from 'next/script';
import { cn } from '~/lib/utils';
import { Breadcrumbs } from '~/types/breadcrumb';

interface BreadCrumbJsonLDProps {
  breadCrumbs: Breadcrumbs;
}

export const BreadCrumb = ({ breadCrumbs }: BreadCrumbJsonLDProps) => {
  const displayBreadcrumbs = breadCrumbs.breadcrumbs;

  return (
    <>
      <ol className="breadcrumb">
        {displayBreadcrumbs.map((breadCrumb, index) => {
          return (
            <li
              key={index}
              className={cn(
                displayBreadcrumbs.length === index + 1 && 'active',
              )}
            >
              {/* 一番最後のアイテムの場合は、classにactiveを追加 */}
              {displayBreadcrumbs.length === index + 1 ? (
                <>{breadCrumb.title}</>
              ) : (
                <a href={breadCrumb.path}>{breadCrumb.title}</a>
              )}
            </li>
          );
        })}
      </ol>
      <BreadCrumbJsonLD breadCrumbs={breadCrumbs} />
    </>
  );
};

// 構造化JSONの吐き出し
const BreadCrumbJsonLD = ({ breadCrumbs }: BreadCrumbJsonLDProps) => {
  return (
    <Script
      id="breadcrumb-json-ld"
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(breadCrumbs.json_ld) }}
    />
  );
};
